import { Component } from '@angular/core';

@Component({
	selector: 'app-quoter-error',
	imports: [],
	templateUrl: './quoter-error.component.html',
	styleUrl: './quoter-error.component.scss',
})
export class QuoterErrorComponent {}
